// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import UserRegisterCompleted from "./Components/UserRegister/UserRegisterCompleted";
import UserRegisterError from "./Components/UserRegister/UserRegisterError";
import UserRegisterForm from "./Components/UserRegister/UserRegisterForm";

const EnvanteriumLogo = require("../../Assets/Logo/hero_logo.png");

type PropsType = {
  location: Object,
  history: Object,
  match: Object,
  userregister: Object,
  translate: string => void,
  userRegisterFormElementValueChange: (string, string) => void,
  userRegisterControlElementValueChange: (string, string) => void,
  userRegisterFormSubmit: (Object, string, string) => void,
  userRegisterFormErrorRelease: () => void
};

type StateType = {};

class UserRegister extends Component<PropsType, StateType> {
  render() {
    const {
      userregister,
      translate,
      userRegisterFormElementValueChange,
      userRegisterControlElementValueChange,
      userRegisterFormSubmit,
      userRegisterFormErrorRelease
    } = this.props;
    const { formElements, controlElements, status } = userregister;
    const { request_id, related_secret } = this.props.match.params;
    return (
      <div className="layout-centered public-account-pages-layout-centered">
        <main className="main-content">
          <div className="bg-white rounded shadow-7 w-800 mw-750 p-6">
            <Link to="/" className="btn btn-outline-secondary btn-label">
              <label>
                <i className="fas fa-arrow-left" />
              </label>
              {translate("GlobalLocale.return_to_homepage")}
            </Link>
            <div className="row text-center">
              <div className="col-md-12">
                <img src={EnvanteriumLogo} alt="envanterium-hero-logo" className="h-100px" />
              </div>
            </div>
            <div className="h-20px" />
            {(() => {
              if (status.isRegisterSuccessful) {
                return <UserRegisterCompleted translate={translate} />;
              } else if (status.hasError) {
                return (
                  <UserRegisterError
                    translate={translate}
                    userRegisterFormErrorRelease={userRegisterFormErrorRelease}
                  />
                );
              } else {
                return (
                  <UserRegisterForm
                    formElements={formElements}
                    controlElements={controlElements}
                    status={status}
                    request_id={request_id}
                    related_secret={related_secret}
                    translate={translate}
                    userRegisterFormElementValueChange={userRegisterFormElementValueChange}
                    userRegisterControlElementValueChange={userRegisterControlElementValueChange}
                    userRegisterFormSubmit={userRegisterFormSubmit}
                  />
                );
              }
            })()}
          </div>
        </main>
      </div>
    );
  }
}

export default UserRegister;



// WEBPACK FOOTER //
// ./src/Components/PublicAccountPages/UserRegister.js